import { takeLatest } from 'redux-saga/effects';
import { initializeApp } from './handlers/initializeApp';
import { APP_INITIALIZE } from './actions';

export default function* initialSaga(): Generator {
  yield takeLatest(APP_INITIALIZE, initializeApp);
}
